import React from 'react'

const SvgCalendarClockFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M16 2c.667 0 1 .314 1 .941V4h1c1.333 0 2 .667 2 2v2H4V6.004C4 4.668 4.667 4 6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941zM18 10a7.998 7.998 0 00-7.006 4.136c.003-.044.006-.09.006-.136 0-.667-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h1c.275 0 .493-.058.654-.172a7.943 7.943 0 00-.59 2.174L10 17h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h1l.063-.003A7.943 7.943 0 0011.073 22H6c-1.333 0-2-.667-2-2V10h14z' />
    <path fillRule='evenodd' clipRule='evenodd' d='M18 22a4 4 0 110-8 4 4 0 010 8zm0 2a6 6 0 110-12 6 6 0 010 12z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 15.25a.75.75 0 01.75.75v1.69l.78.78a.75.75 0 11-1.06 1.06l-1-1a.75.75 0 01-.22-.53v-2a.75.75 0 01.75-.75z'
    />
  </svg>
)

export default SvgCalendarClockFilled
